import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from '@vivaahealth/design-system';

import { htmlFromMarkdown } from '../../utils/markdown';

import styles from './index.module.css';
import x from 'common/dist/assets/x.svg';

interface Props extends Modal.Props {
  headerText?: string;
  helpText: string;
  onHandleHelpful: (helpful: boolean) => Promise<void>;
}

const ContextualHelpModal: React.FC<Props> = ({
  headerText,
  helpText,
  onHandleHelpful,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      appElement={document.getElementById('root') ?? undefined}
      className={styles.ModalBody}
      overlayClassName={styles.Overlay}
      shouldCloseOnOverlayClick={true}
      {...props}
    >
      <div className={classNames(styles.ModalHeader, styles.Prompt)}>
        {headerText}
        {props.onRequestClose && (
          <img
            className={styles.Icon}
            onClick={props.onRequestClose}
            alt={t('close')}
            src={x}
          />
        )}
      </div>
      <div className={styles.ModalContent}>
        <div
          className={styles.Dialog}
          dangerouslySetInnerHTML={{
            __html: htmlFromMarkdown(helpText),
          }}
        />

        <hr />
        <div className={styles.Prompt}>{t('Was this helpful?')}</div>
        <div className={styles.ButtonWrapper}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => onHandleHelpful(false)}
          >
            {t('No')}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => onHandleHelpful(true)}
          >
            {t('Yes')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContextualHelpModal;
